import AppHeader from '../components/AppModule/App/AppHeader'

// eslint-disable-next-line import/prefer-default-export
export const DEFAULT_PAGE_NAV_STATE = {
  backgroundIsHidden: false,
  headerIsFixed: false,
  accoundNavIsHidden: false,
  Header: AppHeader,
  pageId: `unknown`,
  pageBackgroundColour: `background`,
}
